// extracted by mini-css-extract-plugin
module.exports = {"layout":"global-map_layout__trRaq","overlay":"global-map_overlay__IhtpN","region":"global-map_region__klDGV","regionContainer":"global-map_regionContainer__sor22"};